import { render, staticRenderFns } from "./CardLeftPanel.vue?vue&type=template&id=704b39c4&scoped=true&"
import script from "./CardLeftPanel.vue?vue&type=script&lang=js&"
export * from "./CardLeftPanel.vue?vue&type=script&lang=js&"
import style0 from "./CardLeftPanel.vue?vue&type=style&index=0&id=704b39c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b39c4",
  null
  
)

export default component.exports